import ConfirmationCheckIcon from '../../../../../images/confirmation-check.svg';
import { Colors } from '../../../../../themes/colors';
import CustomPortal from '../../../../commonComponents/CustomPortal';

export const SuccessPopup = ({ onOk }) => (
  <CustomPortal
    title="Job Posted"
    Icon={ConfirmationCheckIcon}
    textStyle={{ textAlign: 'center' }}
    submitText="Done"
    submitPressed={onOk}
    containerStyle={{ paddingInline: 50, paddingTop: 30 }} // Optional
    hideLeftButton
  >
    <p style={{ color: Colors.neutral_500, fontSize: 16, textAlign: 'center' }}>
      Job has been posted and is now active to professionals in their area. The office has been
      charged according to the plan’s pricing.
    </p>
  </CustomPortal>
);
